module.exports = __webpack_public_path__ + "img/celtic4.bcb36ae4.jpg";